import axios from "axios";

async function uploadToS3(file, progress, error) {
  const matches = file.name.match(/\.([a-zA-Z0-9]+)$/);
  const fileExtension = matches ? matches[1] : "txt";

  try {
    const res = await axios.post(`/documents`, {
      contentType: file.type || "application/octet-stream",
      extension: fileExtension,
    });

    await axios.put(res.data.uploadURL, file, {
      headers: { "Content-Type": file.type },
      onUploadProgress: (progressEvent) => {
        const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
        progress(percentCompleted);
      },
    });

    progress(100);
    return {
      path: res.data.uploadURL,
      documentId: res.data.documentId,
    };
  } catch (err) {
    error("There was an error uploading your file.");
    throw err;
  }
}

/**
 * FormKit Plugin for S3 Upload
 */
const S3UploaderPlugin = (node) => {
  if (node.props.type === "file") {
    let isInternalUpdate = false;
    node.on("input", async ({ payload }) => {
      if (isInternalUpdate || !Array.isArray(payload)) return;

      let changed = false;
      for (const fileItem of payload) {
        if (fileItem.file && !fileItem.uploadResult) {
          try {
            fileItem.uploadResult = "uploading";
            const result = await uploadToS3(
              fileItem.file,
              () => {},
              (error) => {
                console.error(error);
              },
            );
            fileItem.path = result;
            fileItem.uploadResult = "complete";
            changed = true;
          } catch (err) {
            fileItem.uploadResult = null;
            console.error("Upload failed", err);
          }
        }
      }
      if (changed) {
        isInternalUpdate = true;
        node.input([...payload]);
        isInternalUpdate = false;
      }
    });
  }
};

export default S3UploaderPlugin;
